<div class="main-nav">
    <div class="logo">
        <img src="/assets/icons/logo.png" alt="Logo Symia" width="200" height="123">
    </div>

    <section class="welcome-text" *ngIf="user">
        <p>
            {{'main.nav.welcome.shortLabel' | translate}}, <br>
            {{ user.name }}
        </p>
    </section>

    <mat-nav-list (click)="onCloseSidenav()">
        <mat-accordion>
            <app-nav-list *ngFor="let link of navLinks" [link]="link"></app-nav-list>
        </mat-accordion>
    </mat-nav-list>

    <mat-nav-list class="info-nav" (click)="onCloseSidenav()">
        <app-nav-list *ngFor="let link of infoLinks" [link]="link" [isLittleMode]="true"></app-nav-list>
    </mat-nav-list>

    <mat-list class="version">
        <mat-list-item>
            <a href="https://www.bizzdev.com/" target="_blank">
                <img src="/assets/icons/bizzdev.png" alt="Logo Bizzdev" width="44" height="28">
            </a>
            {{'main.nav.version.shortLabel' | translate}}: {{appVersion}}
        </mat-list-item>
        <mat-list-item *ngIf="isLocalTranslations" class="local-translation">
            - Local Translations: ON -
        </mat-list-item>
    </mat-list>
</div>
